import { render, staticRenderFns } from "./VisualizacaoValidacaoModal.vue?vue&type=template&id=e0aa0162&lang=pug"
import script from "./VisualizacaoValidacaoModal.vue?vue&type=script&lang=js"
export * from "./VisualizacaoValidacaoModal.vue?vue&type=script&lang=js"
import style0 from "./VisualizacaoValidacaoModal.vue?vue&type=style&index=0&id=e0aa0162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports